export default "assets/images/icons/slider-arrow-bd884191.svg";